import { useOutletContext } from "react-router-dom"

import {
  INVALID_ACCOUNT_DWOLLA_ERROR_CODES,
  INSUFFICIENT_FUNDS_DWOLLA_ERROR_CODES
} from "@components/Dwolla/Constants"

import {
  TRANSACTION_TYPES,
  TRANSACTION_STATUS
} from "@components/Domain/Constants"

const { ERROR, FAILED } = TRANSACTION_STATUS

const useFailedTransaction = (investmentId) => {
  const { getInvestmentTransactions } = useOutletContext()

  const investmentTransactions = getInvestmentTransactions(investmentId)
  const [ transaction ] = investmentTransactions
    .filter(t => t.status === ERROR || t.status === FAILED)

  let isInvalidInvestorBankAccount = false
  let isInsufficientFundsInvestorBankAccount = false

  if (!transaction) {
    return {
      isFailed: false,
      isInvalidInvestorBankAccount,
      isInsufficientFundsInvestorBankAccount
    }
  }

  const { type, statusReason } = transaction
  const isFundingTransaction = type === TRANSACTION_TYPES.FUNDING

  if (statusReason) {
    const { code } = JSON.parse(statusReason)
    const isInvalidBankAccount = INVALID_ACCOUNT_DWOLLA_ERROR_CODES.includes(code)
    const isInsufficientFundsBankAccount = INSUFFICIENT_FUNDS_DWOLLA_ERROR_CODES.includes(code)

    isInvalidInvestorBankAccount = isInvalidBankAccount && isFundingTransaction
    isInsufficientFundsInvestorBankAccount = isInsufficientFundsBankAccount && isFundingTransaction
  }

  const isFailed = isInvalidInvestorBankAccount || isInsufficientFundsInvestorBankAccount

  return { isFailed, isInvalidInvestorBankAccount, isInsufficientFundsInvestorBankAccount }
}

export default useFailedTransaction